(function () {
  function getGA4ClientId() {
    const match = document.cookie.match(/_ga=GA\d\.\d\.(\d+\.\d+)/);
    return match ? match[1] : null;
  }

  function sendGAClientIdToCart() {
    const gaClientId = getGA4ClientId();
    if (gaClientId) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { ga_client_id: gaClientId }
        })
      }).catch((err) => console.error("GA client ID cart attribute error:", err));
    }
  }

  const originalFetch = window.fetch;

  window.fetch = function (...args) {
    const [resource, config] = args;
    const url = typeof resource === "string" ? resource : resource.url;

    return originalFetch.apply(this, args).then((response) => {
      if (url && url.includes("/cart/add")) {
        response
          .clone()
          .json()
          .then((data) => {
            // Shopify's /cart/add.js response shape differs slightly
            // depending on whether it's a single item or multiple (bulk add).
            const items = data.items ? data.items : [data];

            const dlItems = items.map((item) => ({
              item_id: item.sku || item.variant_id,
              item_name: item.product_title || item.title,
              price: (item.price / 100), // Shopify returns price in cents
              quantity: item.quantity
            }));

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
              event: "add_to_cart",
              ecommerce: {
                currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "GBP",
                value: dlItems.reduce((sum, i) => sum + (i.price * i.quantity), 0),
                items: dlItems
              }
            });

            // Attach the real GA4 client ID to the cart so it survives
            // through to checkout, where the Web Pixel can read it.
            sendGAClientIdToCart();
          })
          .catch((err) => console.error("Add to cart tracking error:", err));
      }
      return response;
    });
  };

  // Also send it once on page load, in case someone reaches checkout
  // via an existing cart without triggering a new /cart/add this session.
  sendGAClientIdToCart();
})();